(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("React"), require("mobxReact"), require("ReactRouter"), require("ReactDOM"), require("History"), require("weaWorkflow"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx", "React", "mobxReact", "ReactRouter", "ReactDOM", "History", "weaWorkflow"], factory);
	else if(typeof exports === 'object')
		exports["weaWorkflow"] = factory(require("mobx"), require("React"), require("mobxReact"), require("ReactRouter"), require("ReactDOM"), require("History"), require("weaWorkflow"));
	else
		root["weaWorkflow"] = factory(root["mobx"], root["React"], root["mobxReact"], root["ReactRouter"], root["ReactDOM"], root["History"], root["weaWorkflow"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_28__, __WEBPACK_EXTERNAL_MODULE_91__, __WEBPACK_EXTERNAL_MODULE_790__, __WEBPACK_EXTERNAL_MODULE_792__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition